module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Library-777324c3655858271063b8dabc83d262.svg";